module.exports = __webpack_public_path__ + "static/media/lincoln-off-app-provider-icon.a421383f.svg";